import moment from "moment";
import { getQueryVariables } from "@/lib/url";

export const TIME_FORMAT = "hh:mm a";

function nextHalfHour() {
  const startsAt = moment();

  // use date from query string if provided
  const { start } = getQueryVariables();

  if (start) {
    const [year, month, date] = start
      .split("-")
      .map((item: string) => parseInt(item));

    startsAt.set({ year, month: month - 1, date });
  }

  // round up to the nearest half hour
  const remainder = 30 - (startsAt.minute() % 30);
  return startsAt.add(remainder, "minutes");
}

export enum Weekday {
  sunday = 0,
  monday = 1,
  tuesday = 2,
  wednesday = 3,
  thursday = 4,
  friday = 5,
  saturday = 6
}

export enum RecurrenceRuleType {
  DailyRule = "DailyRule",
  WeeklyRule = "WeeklyRule",
  MonthlyRule = "MonthlyRule",
  YearlyRule = "YearlyRule"
}

export enum RecurrencePresetName {
  daily = "daily",
  weekdays = "weekdays",
  weekly = "weekly",
  biweekly = "biweekly",
  monthly = "monthly",
  yearly = "yearly",
  custom = "custom"
}

export class ParticipantAttributes {
  participant_type: "User";
  participant_id: number;
}

export class Participants {
  user_id: number;
  name: string;
}

export class RecurrenceRule {
  type: RecurrenceRuleType;
  interval: number;
  days?: Array<number>;
  occurrence?: Array<number>;
  ends?: "never" | "on" | "after" = "never";
  until?: Date;
  count?: number;

  constructor(params: Partial<RecurrenceRule>) {
    Object.assign(this, params);
  }
}

export class CalendarEvent {
  id: number | null;
  name = "";
  exclusive = true;
  all_day = false;
  starts_at = nextHalfHour().toDate();
  ends_at = moment(this.starts_at).add(30, "minutes").toDate();
  recurring = false;
  participants_attributes: ParticipantAttributes[] = [];
  participants?: Participants[];
  recurrence_preset?: RecurrencePresetName = RecurrencePresetName.weekly;
  recurrence_rules: RecurrenceRule[] = [];

  constructor(params: Partial<CalendarEvent> = {}) {
    Object.assign(this, params);
  }

  get technicianIds() {
    return this.participants_attributes
      .filter(
        (attrs: ParticipantAttributes) => attrs.participant_type === "User"
      )
      .map((attrs: ParticipantAttributes) => attrs.participant_id);
  }

  get startTime() {
    return moment(this.starts_at).format(TIME_FORMAT);
  }

  get endTime() {
    return moment(this.ends_at).format(TIME_FORMAT);
  }
}
